module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/pleg24-0db5288bb1ce518f150e69d634a4bdda.jpg";